module.exports = __webpack_public_path__ + "static/media/close.361da332.svg";